import React from 'react';
import { Modal, Button, Collapse, Row, Col, Space, Typography } from 'antd';

const { Panel } = Collapse;
const { Title, Text } = Typography;

interface ProcurementDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  procurementDetails: any;
  openProcurementDetailsModal: () => void;
}

const ProcurementDetailsModal: React.FC<ProcurementDetailsModalProps> = ({
                                                                           visible,
                                                                           onClose,
                                                                           procurementDetails
                                                                         }) => {
  if (!procurementDetails) return null;

  const {
    agent,
    vendor,
    procurement_type,
    approved,
    paid,
    products = [],
    comments = []
  } = procurementDetails;

  const totalProducts = products.length;
  const totalPurchasePrice = products.reduce(
    (acc: number, item: any) => acc + Number(item.purchase_price || 0),
    0
  );
  const totalRetailPrice = products.reduce(
    (acc: number, item: any) => acc + Number(item.retail_price || 0),
    0
  );

  return (
    <Modal
      title="View Procurement Details"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      destroyOnClose
      centered
      className="custom-modal"
    >
      <Row gutter={16}>
        <Col span={12}>
          <Title level={5}>Agent</Title>
          <Text>{`${agent?.first_name || ''} ${agent?.last_name || ''}`}</Text>

          <div style={{ marginTop: 10 }}>
            <Title level={5}>Vendor</Title>
            <Text>{vendor?.vendor_name || ''}</Text>
          </div>

          <div style={{ marginTop: 10 }}>
            <Title level={5}>Procurement Type</Title>
            <Text>{procurement_type}</Text>
          </div>
        </Col>

        <Col span={12}>
          <Title level={5}>Status</Title>
          <div style={{ marginBottom: 10 }}>
            <Text strong>Approved:</Text> <Text>{approved === true ? 'Yes' : approved === false ? 'No' : 'Pending'}</Text>
          </div>
          <div>
            <Text strong>Paid:</Text> <Text>{paid ? 'Yes' : 'No'}</Text>
          </div>

          {comments.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <Title level={5}>Comments</Title>
              {comments.map((comment: any, index: number) => (
                <div key={index} style={{ marginBottom: 10 }}>
                  <Text>{comment.text || '-'}</Text>
                </div>
              ))}
            </div>
          )}
        </Col>
      </Row>

      <div style={{ marginTop: 20 }}>
        <Title level={5}>Products</Title>
        <Collapse expandIconPosition="right" defaultActiveKey={['0']} accordion>
          {products.map((product: any, index: number) => (
            <Panel header={`Product ${index + 1}`} key={index}>
              <Row gutter={16}>
                <Col span={12}>
                  <Text strong>Product Type:</Text> <Text>{product.product_type?.name || 'N/A'}</Text><br />
                  <Text strong>Brand:</Text> <Text>{product.brand?.name || 'N/A'}</Text><br />
                  <Text strong>Model ID:</Text> <Text>{product.model_id || 'N/A'}</Text><br />
                </Col>
                <Col span={12}>
                  <Text strong>Quantity:</Text> <Text>{product.quantity}</Text><br />
                  <Text strong>IMEI (1):</Text> <Text>{product.imei || '-'}</Text><br />
                  <Text strong>IMEI (2):</Text> <Text>{product.imei2 || '-'}</Text><br />
                </Col>
              </Row>
            </Panel>
          ))}
        </Collapse>
      </div>

      <div style={{ marginTop: 20 }}>
        <Title level={5}>Summary</Title>
        <Row gutter={16}>
          <Col span={8}>
            <Text strong>Total Products:</Text> <Text>{totalProducts}</Text>
          </Col>
          <Col span={8}>
            <Text strong>Total Purchase Price:</Text> <Text>{totalPurchasePrice}</Text>
          </Col>
          <Col span={8}>
            <Text strong>Total Retail Price:</Text> <Text>{totalRetailPrice}</Text>
          </Col>
        </Row>
      </div>

      <div style={{ marginTop: 20 }}>
        <Space>
          <Button onClick={onClose} type="default">
            Close
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default ProcurementDetailsModal;
